// 动态表头仍由原页面维护，只在指定位置补充当前版本周期。
export function withPeriodColumn (columns, after, enabled = true) {
  const result = columns.filter(item => !['shippingPeriod', 'deliveryCycle', 'sendCycle'].includes(item.prop) && !/发货周期/.test(item.label))
  if (enabled) {
    const index = result.findIndex(item => item.prop === after || item.label === after)
    result.splice(index >= 0 ? index + 1 : result.length, 0, { prop: 'shippingPeriod', label: '发货周期', width: 150 })
  }
  return result
}
